const EmpWelcome = () =>
  import('@/views/main/externalStatistics/EmpWelcome/EmpWelcome.vue')
export default {
  path: '/main/externalStatistics/empWelcome',
  name: 'EmpWelcome',
  component: EmpWelcome,
  children: []
}

